export function calculateWinner(board) {
    const rows = 10;
    const cols = 6;

    // Horizontally
    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols - 3; col++) {
            if (board[row][col] !== null &&
                board[row][col] === board[row][col + 1] &&
                board[row][col] === board[row][col + 2] &&
                board[row][col] === board[row][col + 3]) {
                return {
                    player: board[row][col],
                    winningCombination: [[row, col], [row, col + 1], [row, col + 2], [row, col + 3]]
                }
            }
        }
    }

    for (let row = 0; row < rows - 3; row++) {
        for (let col = 0; col < cols; col++) {
            if (board[row][col] !== null &&
                board[row][col] === board[row + 1][col] &&
                board[row][col] === board[row + 2][col] &&
                board[row][col] === board[row + 3][col]) {
                return {
                    player: board[row][col],
                    winningCombination: [[row, col], [row + 1, col], [row + 2, col], [row + 3, col]]
                }
            }
        }
    }

    for (let row = 0; row < rows - 3; row++) {
        for (let col = 0; col < cols - 3; col++) {
            if (board[row][col] !== null &&
                board[row][col] === board[row + 1][col + 1] &&
                board[row][col] === board[row + 2][col + 2] &&
                board[row][col] === board[row + 3][col + 3]) {
                return {
                    player: board[row][col],
                    winningCombination: [[row, col], [row + 1, col + 1], [row + 2, col + 2], [row + 3, col + 3]]
                }
            }
        }
    }

    for (let row = 0; row < rows - 3; row++) {
        for (let col = 3; col < cols; col++) {
            if (board[row][col] !== null &&
                board[row][col] === board[row + 1][col - 1] &&
                board[row][col] === board[row + 2][col - 2] &&
                board[row][col] === board[row + 3][col - 3]) {
                return {
                    player: board[row][col],
                    winningCombination: [[row, col], [row + 1, col - 1], [row + 2, col - 2], [row + 3, col - 3]]
                }
            }
        }
    }

    return { player: null, winningCombination: null };
}

function isBoardFull(board) {
    return board.every(col => col.every(cell => cell !== null));
}

function evaluateBoard(board) {
    const winner = calculateWinner(board);

    if (winner.player === "X") {
        return -10; // X wins
    } else if (winner.player === "O") {
        return 10; // O wins
    } else {
        return 0; // Tie or game still ongoing
    }
}

function minimax(board, depth, maximizingPlayer) {
    const scores = {
        X: -10 + depth,
        O: 10 - depth,
        tie: 0,
    };

    const winner = calculateWinner(board);
    const isFull = isBoardFull(board);

    if (winner.player !== null) {
        return scores[winner.player];
    } else if (isFull) {
        return scores.tie;
    } else if (depth === 0) {
        return evaluateBoard(board); // Evaluate the board at the specified depth
    }

    if (maximizingPlayer) {
        let maxScore = -Infinity;

        for (let col = 0; col < 10; col++) {
            if (board[col][0] === null) {
                const newBoard = board.map(row => [...row]);
                const row = getEmptyRow(newBoard, col);
                newBoard[col][row] = "O";

                const score = minimax(newBoard, depth - 1, false);
                maxScore = Math.max(maxScore, score);
            }
        }

        return maxScore;
    } else {
        let minScore = Infinity;

        for (let col = 0; col < 10; col++) {
            if (board[col][0] === null) {
                const newBoard = board.map(row => [...row]);
                const row = getEmptyRow(newBoard, col);
                newBoard[col][row] = "X";

                const score = minimax(newBoard, depth - 1, true);
                minScore = Math.min(minScore, score);
            }
        }

        return minScore;
    }
}

export function findBestMove(board, depth) {
    const centralCols = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].sort((a, b) => 0.5 - Math.random()); // Order of central columns

    let bestScore = -Infinity;
    let bestMove = null;

    for (let i = 0; i < centralCols.length; i++) {
        const col = centralCols[i];

        if (board[col][0] === null) {
            const newBoard = board.map(row => [...row]);
            const row = getEmptyRow(newBoard, col);
            newBoard[col][row] = "O";

            const score = minimax(newBoard, depth, false);

            if (score > bestScore) {
                bestScore = score;
                bestMove = col;
            }
        }
    }

    return bestMove;
}

function getEmptyRow(board, col) {
    for (let row = 5; row >= 0; row--) {
        if (board[col][row] === null) {
            return row;
        }
    }
    return -1;
}